import { ColorsService, ColorLevel, ColorName } from 'src/app/_common/services';

export class ColorsLegendQuotaSettings
{
    left?: string;
    right?: string;
}

export class ColorsQuotaSettings
{
    back?: string;
    legend?: {
        left?: string;
        right?: string;
    };
    conso?: string;
    needed?: string;
    notEnough?: string;
}

export class QuotaSettings
{
    width?: number;
    height: number = 12;
    legend?: string;
    unit?: {
        singular?: string;
        plural?: string;
    };
    colors?: ColorsQuotaSettings;

    constructor()
    {
        this.colors = new ColorsQuotaSettings();
    }

    public static mapperFromObject (source: any): QuotaSettings
    {
        const target = new QuotaSettings();
        const defaultQuotaSettings = new DefaultQuotaSettings();

        Object.assign(target, defaultQuotaSettings, { ...source });
        if (source.colors)
        {
            Object.assign(target.colors, defaultQuotaSettings.colors, { ...source.colors });
        }

        return target;
    }
}

export class DefaultQuotaSettings extends QuotaSettings
{

    constructor()
    {
        super();

        this.colors = {
            back: ColorsService.getBasicColor(ColorLevel.Normal, ColorName.White),
            legend:
            {
                left: ColorsService.getMessageColor(ColorLevel.Normal, ColorName.Blue),
                right: ColorsService.getMessageColor(ColorLevel.Normal, ColorName.Blue),
            },
            conso: ColorsService.getMessageColor(ColorLevel.Normal, ColorName.Blue),
            needed: ColorsService.getMessageColor(ColorLevel.Normal, ColorName.Success),
            notEnough: ColorsService.getMessageColor(ColorLevel.Normal, ColorName.Danger),
        } as ColorsQuotaSettings;
    }
}
